import React, { Component } from 'react';
import { Card, ListGroup } from 'react-bootstrap';

export class ReliefSociety extends Component {
    constructor(props) {
        super(props);
        this.state = {
          error: null,
          isLoaded: false,
          items: []
        };
      }

    componentDidMount() {
        fetch("/data/reliefsociety.json")
            .then(res => res.json())
            .then(
            (result) => {
                this.setState({
                isLoaded: true,
                items: result.documents
                });
            },
            (error) => {
                this.setState({
                isLoaded: true,
                error
                });
            }
        )
    }

    render() {
        const { error, isLoaded, items } = this.state;
        if (error) {
        return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
        return <div>Loading...</div>;
        } else {
            return <div>
          <h3>Relief Society</h3>
          <br />
          <Card>
                <Card.Title>
                  Class Sunday @ 1:10pm - 2:00pm
                </Card.Title>
                <Card.Body>
                    <h4>
                        Meeting every 2nd and 4th Sunday of each month.
                    </h4>             
                </Card.Body>              
          </Card>
          <Card>
                <Card.Title>
                  Announcements
                </Card.Title>
                <Card.Body>
                    <ListGroup>
                    {items.length > 0 ? items.map(item => (
                    <ReliefSocietyLink
                        title={item.title}
                        link={item.link}/>
                    )) : <p>{"No Announcements Right Now!"}</p>}
                    </ListGroup>         
                </Card.Body>              
          </Card>
    </div>;
        }
    }
  }

  export class ReliefSocietyLink extends Component {
    render() {
        if (this.props.link === '')
        {
            return <ListGroup.Item>
                <h5>
                {this.props.title}
                </h5>
            </ListGroup.Item>
        }
        return <ListGroup.Item>
        <a href={this.props.link} alt={this.props.title} target="_blank" rel="noopener noreferrer">
              <h5>
              {this.props.title}
              </h5>
          </a>  
        </ListGroup.Item>;
    }
  }

  export class ListGroupLinkItem extends Component {
      render() {
      return <ListGroup.Item>
          <a href={this.props.link}>{this.props.text}</a>
          </ListGroup.Item>
      }
  }

  export default ReliefSociety;